import React from "react";
import "../blocks/Footer.css";
import img_1 from "../../src/images/draggableImages/img_1.webp";
import img_2 from "../../src/images/draggableImages/img_2.webp";
import img_3 from "../../src/images/draggableImages/img_3.webp";
import img_4 from "../../src/images/draggableImages/img_4.webp";
import img_5 from "../../src/images/draggableImages/img_5.webp";
import img_6 from "../../src/images/draggableImages/img_6.webp";
import img_7 from "../../src/images/draggableImages/img_7.webp";
import img_8 from "../../src/images/draggableImages/img_8.webp";
import img_9 from "../../src/images/draggableImages/img_9.webp";

function Footer() {
  React.useEffect(() => {
    setupDraggableImages();
  });

  function setupDraggableImages() {
    const container = document.getElementById("footer_container");
    const images = container.querySelectorAll("img");
    let maxZIndex = 6;

    images.forEach((img) => {
      img.style.position = "absolute";
      img.style.userDrag = "none";
      img.setAttribute("draggable", false);

      makeImageDraggable(img);
    });

    function makeImageDraggable(img) {
      let isDragging = false;
      let currentX;
      let currentY;
      let initialX;
      let initialY;

      currentX = parseFloat(img.style.left) || img.offsetLeft || 0;
      currentY = parseFloat(img.style.top) || img.offsetTop || 0;

      img.addEventListener("mousedown", startDragging);
      img.addEventListener("dragstart", (e) => e.preventDefault());
      document.addEventListener("mousemove", drag);
      document.addEventListener("mouseup", stopDragging);

      img.addEventListener("touchstart", startDragging, { passive: false });
      img.addEventListener("touchmove", drag, { passive: false });
      img.addEventListener("touchend", stopDragging);
      img.addEventListener("touchcancel", stopDragging);

      function startDragging(e) {
        e.preventDefault();
        const clientX = e.type.includes("touch")
          ? e.touches[0].clientX
          : e.clientX;
        const clientY = e.type.includes("touch")
          ? e.touches[0].clientY
          : e.clientY;

        initialX = clientX - currentX;
        initialY = clientY - currentY;
        isDragging = true;
        img.style.zIndex = maxZIndex++;
      }

      function drag(e) {
        if (!isDragging) {
          return;
        }

        e.preventDefault();
        const clientX = e.type.includes("touch")
          ? e.touches[0].clientX
          : e.clientX;
        const clientY = e.type.includes("touch")
          ? e.touches[0].clientY
          : e.clientY;

        currentX = clientX - initialX;
        currentY = clientY - initialY;
        img.style.left = currentX + "px";
        img.style.top = currentY + "px";
      }

      function stopDragging() {
        isDragging = false;
      }
    }
  }

  return (
    <footer className="footer" id="footer_container">
      <p className="footer__text">
        Также Ян Зубков находится в уголовном розыске США
      </p>
      <span className="footer__span">с 2018 года</span>
      <img className="footer__image" src={img_1} alt="icon" />
      <img className="footer__image" src={img_2} alt="icon" />
      <img className="footer__image" src={img_3} alt="icon" />
      <img className="footer__image" src={img_4} alt="icon" />
      <img className="footer__image" src={img_5} alt="icon" />
      <img className="footer__image" src={img_6} alt="icon" />
      <img className="footer__image" src={img_7} alt="icon" />
      <img className="footer__image" src={img_8} alt="icon" />
      <img className="footer__image" src={img_9} alt="icon" />
    </footer>
  );
}

export default Footer;
